import { Anchor } from '@/components/blocks/Anchor'
import { ExpandableSectionGroupBlock } from '@/components/blocks/ExpandableSectionGroupBlock'
import { HiddenAnchor } from '@/components/blocks/HiddenAnchor'
import { TableOfContents } from '@/components/blocks/TableOfContents'
import { StructuredText } from 'react-datocms'
import { LegalPageRecord } from './LegalPage'
import styled from 'styled-components'

type LegalPageContentProps = {
  page: LegalPageRecord
}

export const StyledOverrideDefaultStructuredTextStyles = styled.div`
  p {
    font-size: var(--font-size-fluid-paragraph-200);
    line-height: var(--line-height-fluid-paragraph-200);
    font-weight: var(--font-weight-fluid-paragraph-200);
    font-family: var(--font-sans-serif-light), var(--font-fallback-sans-serif);
    margin-bottom: var(--spacing-24);
  }
  strong,
  b {
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
  }
  a {
    font-family: var(--font-sans-serif-semibold), var(--font-fallback-sans-serif);
    color: var(--color-text-link);
    text-decoration: none;
  }
  h3,
  h3 strong {
    font-family: var(--font-serif), var(--font-fallback-serif);
    font-size: var(--font-size-fluid-heading-500);
    line-height: var(--line-height-fluid-heading-500);
  }
  h2,
  h2 strong {
    font-family: var(--font-serif), var(--font-fallback-serif);
    font-size: var(--font-size-fluid-heading-600);
    line-height: var(--line-height-fluid-heading-600);
  }
  h1,
  h1 strong {
    font-family: var(--font-serif), var(--font-fallback-serif);
    font-size: var(--font-size-fluid-heading-700);
    line-height: var(--line-height-fluid-heading-700);
  }
`

const renderBlock = (record, pageContent) => {
  switch (record.__typename) {
    case 'ExpandableSectionGroupRecord':
      return <ExpandableSectionGroupBlock record={record} trackingOptions={{ type: 'T&C' }} />
    case 'AnchorRecord':
      return <Anchor record={record} />
    case 'HiddenAnchorRecord':
      return <HiddenAnchor record={record} />
    case 'TableOfContentRecord':
      return <TableOfContents record={record} pageContent={pageContent} />
    default:
      return null
  }
}

export const LegalPageContent = ({ page }: LegalPageContentProps) => (
  <StyledOverrideDefaultStructuredTextStyles>
    <StructuredText data={page.pageContent} renderBlock={({ record }) => renderBlock(record, page.pageContent)} />
  </StyledOverrideDefaultStructuredTextStyles>
)
